import Vue from "vue";
import VueResource from "vue-resource";
import { mapGetters, mapMutations, mapState } from "vuex";

import Moment from "moment";

import dropdownComponent from "@/components/child/dropdown/dropdown.vue";
import notificationComponent from "@/components/parent/notification/list.vue";
import { Component, Watch } from "@/decorators";
import { REACT_LOCALE_MAP, i18n } from "@/i18n";
import PerfisUsuario from "@/models/enum/perfisUsuario";
import UsuarioModel from "@/models/usuarioModel";
import FastActionService from "@/services/fastActionService";
import UsuarioService from "@/services/usuarioService";
import { AppState, Getters, Mutations, SessionActions } from "@/store/store";
import Bus from "@/utils/events/bus";

import ListNotificationComponent from "../notification/list";

Vue.use(VueResource);

import "./topmenu.scss";

@Component({
    components: {
        dropdownComponent,
        notificationComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
            countUnreadedNotification: (state: AppState) => state.notification.countUnreadedNotification,
            totalUnreadCount: (state: AppState) => state.atendimentoContext.totalUnreadCount,
        }),
        ...mapGetters(["HAS_PERMISSAO_PERFIL"] as Getters),
    },
    methods: mapMutations(["LOAD_CONFIGURACOES_FRANQUIA"] as Mutations),
})
export default class TopMenuComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;
    usuarioService = new UsuarioService();
    countUnreadedNotification: number;
    totalUnreadCount: number;
    LOAD_CONFIGURACOES_FRANQUIA: () => void;
    HAS_PERMISSAO_PERFIL: (isRede: boolean, isFranqueador: boolean, isSuporte: boolean) => Promise<boolean>;

    private notificationComponent: ListNotificationComponent = null;

    menuExibicao = false;

    dia: string = Moment(Date()).format("DD/MM");
    semana: string = Moment(Date()).format("dddd");
    sessaoCaixaId = 0;

    temperatura = "";
    temp = 0;
    weatherID = 0;
    icon = "";
    cidade = "";
    temTempo = false;
    notificacoes = 0;
    notificactionChanged = false;
    isAdmin = false;

    nomeUsuario = "";
    versaoSistema = "";
    nomeFranquia = "";
    franquiaCidade = "";
    online = true;

    toggleNavMenu() {
        Bus.$emit("toggle-nav-menu");
    }

    private aumentar() {
        //@ts-ignore
        if (document.body.style.zoom != "100%") {
            //@ts-ignore
            document.body.style.zoom = "100%";
        }
    }

    private diminuir() {
        //@ts-ignore
        if (document.body.style.zoom == "100%") {
            //@ts-ignore
            document.body.style.zoom = "90%";
            //@ts-ignore
        } else if (document.body.style.zoom == "90%") {
            //@ts-ignore
            document.body.style.zoom = "80%";
        } else {
            //@ts-ignore
            document.body.style.zoom = "75%";
        }
    }

    private onAlterarSenha() {
        this.$router.push("/alterar-senha/");
    }

    private onMeuPerfil() {
        this.$router.push("/meu-perfil/");
    }

    private onVerNotasDaVersao() {
        window.open("https://vettech.notion.site/vettech/PharmUP-Notas-da-Vers-o-8fbf742da28b4fde990282ef0ac69cf4");
    }

    private onVerStatusDoSistema() {
        this.$router.push("/status-sistema/");
    }

    private onAdmin() {
        this.$router.push("/admin/");
    }

    private async loadInfosFinanc() {
        try {
            const data = await new FastActionService()
                .getInfosFinanceiro()
                .resolveWithJSON<{ valorPagar?: number; valorReceber?: number; sessaoCaixaId?: number }>();
            this.sessaoCaixaId = data.sessaoCaixaId;
        } catch {}
    }

    //busca clima por lat e long
    private async loadtempo() {
        const reqURL = `https://api.openweathermap.org/data/2.5/weather?q=${this.franquiaCidade},br&APPID=69d3cf86b46f19cf3e049339355533aa`;

        this.$http.get(reqURL).then(
            function (response) {
                this.weatherID = response.data.weather[0].id;
                this.temp = (response.data.main.temp - 273.15).toFixed(0);
                this.cidade = response.data.name;

                if (this.weatherID >= 200 && this.weatherID <= 232) {
                    this.icon = "thunderstorm";
                } else if (this.weatherID >= 300 && this.weatherID <= 321) {
                    this.icon = "shower-rain";
                } else if (this.weatherID >= 500 && this.weatherID <= 531) {
                    this.icon = "rain";
                } else if (this.weatherID >= 600 && this.weatherID <= 622) {
                    this.icon = "snow";
                } else if (this.weatherID >= 701 && this.weatherID <= 781) {
                    this.icon = "mist";
                } else if (this.weatherID == 800) {
                    this.icon = "clear-sky";
                } else if (this.weatherID == 801) {
                    this.icon = "few-clouds";
                } else if (this.weatherID == 802) {
                    this.icon = "scattered-clouds";
                } else if (this.weatherID == 803) {
                    this.icon = "broken-clouds";
                } else if (this.weatherID == 804) {
                    this.icon = "broken-clouds";
                }

                this.temTempo = true;
            },
            function () {},
        );
    }

    @Watch("usuarioLogado")
    private onChangeUsuarioNome() {
        this.nomeUsuario = this.usuarioLogado.nome;

        this.nomeUsuario = this.usuarioLogado.nome.split(" ")[0];
        if (this.nomeUsuario.includes("[SUPORTE]")) {
            this.nomeUsuario += " " + this.usuarioLogado.nome.split(" ")[1];
        }

        this.nomeFranquia = this.usuarioLogado.franquiaNome;
        this.franquiaCidade = this.usuarioLogado.franquiaCidade;
        if (this.franquiaCidade) {
            this.loadtempo();
        }
    }

    @Watch("usuarioLogado.versaoSistema", { immediate: true })
    private onChangeVersaoSistema() {
        this.versaoSistema = "v" + this.limparVersaoSistema(this.usuarioLogado?.versaoSistema);
    }

    private limparVersaoSistema(versao: string | null | undefined): string {
        if (!versao) return "";

        return versao
            .split(".")
            .filter((parte, index, partes) => {
                const ehZero = parte === "0";
                const existeParteNaoZeroDepois = partes.slice(index + 1).some(p => p !== "0");

                return !ehZero || existeParteNaoZeroDepois;
            })
            .join(".");
    }

    private netChanged(on: boolean) {
        if (on) {
            this.$notifySuccess("A sua Conexão foi restabelecida com sucesso!", "Conexão da Internet");
        } else {
            this.$notifySuccess("Aparentemente sua Conexão com internet foi interrompida!", "Conexão da Internet");
        }
    }

    private onChangeIdioma(idioma: string) {
        const canonico = REACT_LOCALE_MAP[idioma] ?? "pt-BR";

        i18n.locale = idioma;
        localStorage.setItem("@PharmUP:Language", canonico);

        const win = window as unknown as { __setReactLanguage?: (lng: string) => void };
        win.__setReactLanguage?.(canonico);
    }

    private async onSair() {
        await this.$store.dispatch(SessionActions.LOGOUT);

        this.$router.push("/login");
    }

    private onShowNotification() {
        this.notificationComponent.show();
    }

    private get hasModuloAtendimento() {
        return (
            this.usuarioLogado.franquia &&
            this.usuarioLogado.franquia.moduloWhatsApp &&
            (this.usuarioLogado.perfilAtendente > 0 ||
                this.usuarioLogado.perfil == PerfisUsuario.Admin ||
                this.usuarioLogado.perfil == PerfisUsuario.Suporte)
        );
    }

    private async mounted() {
        //@ts-ignore
        document.body.style.zoom = "90%";

        Bus.$on("nav-menu-change", menuExibicao => {
            this.menuExibicao = menuExibicao;
        });

        Bus.$on("sessao-caixa-status", status => {
            status ? (this.sessaoCaixaId = 1) : (this.sessaoCaixaId = 0);
        });

        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        this.isAdmin = await this.HAS_PERMISSAO_PERFIL(false, false, false);

        this.notificationComponent = this.$refs.notificationComponent as ListNotificationComponent;

        Promise.all([this.LOAD_CONFIGURACOES_FRANQUIA(), this.loadInfosFinanc()])
            .then(() => {})
            .catch(() => {});

        const versao = localStorage.getItem("@PharmUP:Versao");
        if (!versao && this.usuarioLogado.versaoSistema) {
            localStorage.setItem("@PharmUP:Versao", this.usuarioLogado.versaoSistema);
        } else if (versao !== this.usuarioLogado.versaoSistema) {
            localStorage.setItem("@PharmUP:Versao", this.usuarioLogado.versaoSistema);

            const url = new URL(window.location.href);
            url.searchParams.delete("_");
            const newUrl = url.toString();

            window.location.replace(newUrl);
        }
    }
}
